import React, { Component } from 'react';
import './index.css'

import Bubbles from './components/Bubbles/';

import { NavLink } from 'react-router-dom';


export default class Home extends Component {
  state = {
    text: ''
  }



  componentDidMount = (navText) => {
    let name = 'm a t t _ r a y ;'.split(' ');
    setTimeout(() => {
      this.addLetter(name, 0);
    }, 2500);
  }

  addLetter = (letterArray, position) => {
    const { text } = this.state;
    // immutability!!
    let newText = text.concat(letterArray[position]);
    this.setState({
      text: newText
    })
    if (letterArray[position + 1]) {
      setTimeout(() => {
        this.addLetter(letterArray, position + 1);
      }, Math.max(400 * Math.random(), 125))
    }
  }



  render() {
    const { text } = this.state;
    return (
      <div id="app">
        <header>
          <div className="title">
            <NavLink exact to="/" className="title-text">{text}</NavLink>
            <div className="cursor"></div>
          </div>
          <div className="links">
            > <NavLink to="/projects">projects</NavLink>
            <br/>
            > <NavLink to="/about" >about</NavLink>
            <br/>
            > <NavLink to="/contact" >contact</NavLink>
            <br/>
            > <NavLink to="/resume">Resume</NavLink>
            <br/>
            > <NavLink to="https://github.com/mattray0295" target="_blank" rel="noopener noreferrer">github</NavLink>
            <br/>
            > <NavLink to="https://www.linkedin.com/in/mattray0295/"  target="_blank" rel="noopener noreferrer">LinkedIn</NavLink>
          </div>
        </header>
        <Bubbles />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/index.js